import { RuntimeConfig, WorkbenchConfig } from "../types/Configs";
import appClient, { ResultApi } from "./AppClient";
import { endpoints } from "../../../config";

export default class ConfigService {
    async loadRuntimeConfig(): Promise<ResultApi<RuntimeConfig>> {
        const url = `${endpoints.tasksUrl}settings/runtime`;
        return appClient.get<RuntimeConfig>(url);
    }

    async loadWorkbenchConfig(): Promise<ResultApi<WorkbenchConfig>> {
        const url = `${endpoints.tasksUrl}settings/workbench`;
        return appClient.get<WorkbenchConfig>(url);
    }
}
